<template>
    <div>

        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>用户详情</h2>
            <span style="margin-left: 20px;">用户id：{{ userData.userId }}</span>
        </div>
        <Form @submit.native.prevent label-position="right" :label-colon="true" :label-width="150">
            <Row :gutter="24">
                <Col :span="24">
                    <FormItem label="头像">
                        <div style="width: 58px;height: 58px;border-radius: 50%;overflow:hidden">
                            <img v-if="userData.fileUrl" style="width: 100px;height: 100px" :src="userData.fileUrl" />
                            <embed :src="userIcon" v-else />
                        </div>
                    </FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="昵称">{{ userData.userNickName }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="是否VIP">{{ userData.vipUser?'是':'否' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="用户类型">{{ userData.userTypeName||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="VIP有效期">{{ userData.vipExpireTimeFmt||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="累计付费（美元）">{{ userData.totalPay||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="金币余额">{{ userData.totalBalance||'-' }}</FormItem>
                </Col>
                <Col :span="24">
                    <FormItem label="活跃天数">{{ userData.activeDays||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="最后登录时间">{{ userData.lastLoginTimeFmt||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="Media source">{{ userData.pid||'-' }}</FormItem>
                </Col>
                <Col :span="12">
                    <FormItem label="linkId">{{ userData.linkId||'-' }}</FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import userIcon from '@/assets/icons/user.svg'
export default {
  props:{
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      userIcon
    }
  }
}
</script>
